import { useCallback } from 'react';
import { toastErrorMessage } from 'utils/helpers';
import useSearchParams from 'hooks/useSearchParams';
import { useMutation } from '@apollo/client/react';
import { CalculateExpressLoanDocument, type ExpressLoanInput } from 'graphql/generated/graphql';

const useCalculateExpressLoan = () => {
  const [calculateExpressLoanMutation] = useMutation(CalculateExpressLoanDocument);
  const searchParams = useSearchParams();

  const calculateExpressLoan = useCallback(
    async ({ formData }: { formData: ExpressLoanInput }) => {
      try {
        const res = await calculateExpressLoanMutation({
          variables: { id: searchParams.get('id'), formData },
        });
        return res?.data?.calculateExpressLoan;
      } catch (error) {
        toastErrorMessage(error);
        return undefined;
      }
    },
    [calculateExpressLoanMutation, searchParams],
  );

  return calculateExpressLoan;
};

export default useCalculateExpressLoan;
